export const routes = [
  {
    path: '/indicadores/cadastro',
    component: () => import(/* webpackChunkName: "dashboard" */ './cadastroIndicadores'),
    name: 'indicadores.cadastro'
  }
]
